import { render } from "./AttivitaItem.vue?vue&type=template&id=5e0e12fe&scoped=true"
import script from "./AttivitaItem.vue?vue&type=script&lang=js"
export * from "./AttivitaItem.vue?vue&type=script&lang=js"

import "./AttivitaItem.vue?vue&type=style&index=0&id=5e0e12fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0e12fe"]])

export default __exports__